import { useState } from "react";

import { PriorityRequestFormFilter, PriorityRequestReachabilityFilter } from "@/api";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { usePriorityRequestsQuery } from "@/pages/priority-requests/hooks/usePriorityRequestsQuery";

export function usePriorityRequestsWidget() {
  const { currentUser } = useCurrentUserContext();
  const [selectedCounselorId, setSelectedCounselorId] = useState<string | null>(currentUser.counselorId ?? null);

  const { data, isLoading, isError } = usePriorityRequestsQuery({
    counselorId: selectedCounselorId,
    reachability: PriorityRequestReachabilityFilter.Reachable,
    form: PriorityRequestFormFilter.All,
  });

  const priorityRequests = data ?? [];

  return {
    priorityRequests,
    currentCounselorId: currentUser.counselorId,
    selectedCounselorId,
    onCounselorChange: setSelectedCounselorId,
    isError,
    isEmpty: !isLoading && !isError && priorityRequests.length === 0,
  };
}
